import { useState } from 'react'
import { IVehicleImage } from 'types/vehicleTypes'
import { StyledVehicleDetailImage } from './VehicleDetailImage.style'
import { FyusionDetailImage } from './FyusionDetailImage'
import { getAwaitingCarImage } from 'utils/utils'
interface IProps {
  mainImageUrl: string
  images: IVehicleImage[]
  vehicleInstance: number
  vehicleVin: string
  vehicleMake?: string
}

export const VehicleDetailImage = ({ mainImageUrl, images, vehicleInstance, vehicleVin, vehicleMake }: IProps) => {
  const [imageError, setImageError] = useState<boolean>(false)

  return (
    <StyledVehicleDetailImage>
      {images?.length <= 0 ? (
        mainImageUrl ? (
          <img src={mainImageUrl} alt="Vehicle" className={`${vehicleMake}`} />
        ) : (
          <StyledVehicleDetailImage>
            <div className="margin-top">
              <img src={`../${getAwaitingCarImage(vehicleMake)}`} alt="Awaiting Car" className={`${vehicleMake}`} />
            </div>
          </StyledVehicleDetailImage>
        )
      ) : (
        <div
          onErrorCapture={(e) => {
            setImageError(true)
          }}
        >
          <FyusionDetailImage
            key={vehicleInstance}
            lowRes={images.map((image) => image.ImageURL)}
            thumbnail={mainImageUrl}
            error={imageError}
            vin={vehicleVin}
          ></FyusionDetailImage>
        </div>
      )}
    </StyledVehicleDetailImage>
  )
}

export default VehicleDetailImage
